import React from "react";
import PropTypes from "prop-types";

const Partners = ({partners, tagline}) => {
	if (partners.length === 0) return null;

	return (
		<>
			<p className="count-down-timer__partners__tagline">{tagline}</p>
			<ul className="count-down-timer__partners__list">
				{
					partners.map((partner, index) => {
						return (
							<li className="count-down-timer__partners__item" key={index}>
								<img
									src={partner.image}
									alt={partner.name}
									className="count-down-timer__partners__item__image"
								/>
							</li>
						);
					})
				}
			</ul>
		</>
	)
}

export default Partners;

Partners.propTypes = {
	partners: PropTypes.array,
	tagline: PropTypes.string,
};
